import algoliasearch, { SearchClient, SearchIndex } from "algoliasearch";
import algoliahelper from 'algoliasearch-helper';
import Mustache from "mustache";
import instantsearch, { InstantSearch } from "instantsearch.js";
import { searchBox, refinementList, menuSelect, clearRefinements, queryRuleCustomData, configure, dynamicWidgets, sortBy } from 'instantsearch.js/es/widgets';
import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares';
import { connectInfiniteHits } from 'instantsearch.js/es/connectors';
import { config } from "process";
import Utility from '../classes/utility';
import { MenuItem } from "instantsearch.js/es/connectors/menu/connectMenu";
const bannerSuggestedLinks = require('../../templates/components/search/partials/banners/main').default;
const accordionContainerTemplate = require('../../templates/components/search/filters/accordion-container').default;
import aa from 'search-insights';

// TODO: use these imports for URL syncing of algolia filters
import { history } from 'instantsearch.js/es/lib/routers';
import { simple } from 'instantsearch.js/es/lib/stateMappings';
import SearchEvents, { SearchEventTypes } from "./utilities/search-events";
import utility from "../classes/utility";

enum ViewFilterType {
    Select,
    RefinementList,
    SortBy,
    MultiSelect,
    Clear
}

interface ConfigCssClasses {
    root?: string;
}

interface facet {
    field: string;
    value: string;
    disjunctive?: boolean;
    values?: Array<string>;
}

interface MultiSelectConfig {
    tagContainer?: string;
    tagColours?: Array<any>;
}

interface ViewFilterConfig {
    elementId: string;
    modFn?: (item: MenuItem) => MenuItem;
    capitalize?: boolean;
    templates?: any;
    cssClasses?: any;
    sortBy?: any;
    filterType?: ViewFilterType;
    clearExcludedAttributes?: string[];
    multiSelectConfig?: MultiSelectConfig;
    urlParam?: string;
    urlSpace?: boolean;
}

interface OverrideRender {
    fn: CallableFunction;
    active: boolean;
}

interface SearchClientConfig {
    appId: string;
    apiKey: string;
    indexName: string;
    lazyLoading: boolean;
    hitsPerPage: number;
}

interface SearchInitConfig {
    searchBoxId: string;
    resultContainerId: string;
    activeTemplate: string;
    templates: any;
    placeholderId?: string;
    skeletonTemplates?: any;
    buttonClassTargets?: any;
    customRender?: CallableFunction;
    filtersContainer?: string;
    textboxPlaceholder?: string;
    queryName?: string;
    showOnLoad?: boolean;
    allowEmptyQuery?: boolean;
    cssClasses?: ConfigCssClasses;
    headerText?: string;
    infiniteScroll? : boolean;
    overrideRender?: OverrideRender;
    firstRenderFn?: CallableFunction;
}

class Search {
    clientConfig: SearchClientConfig;
    initConfig: SearchInitConfig;
    client: SearchClient;
    hitsPerPage: number;
    scrollTriggered: boolean = false;
    currentPage: number = 0;
    index: SearchIndex;
    search: InstantSearch;
    resultContainer: HTMLElement;
    lazyloading: boolean;
    facets: Array<facet> = [];
    templates: any = {};
    activeTemplate: string = 'list';
    customRender: CallableFunction;
    customFilter: CallableFunction;
    loading: boolean = false;
    isFirstLoad: boolean = true;
    customSearch: CallableFunction;
    resultsCount:number;
    searchEvents: SearchEvents;
    searchInput: HTMLInputElement;
    public currentHitCount: number = 0;
    public filterURLTranslations: Array<{ key: string, newKey: string }> = [];

    private filterWidgets = [];

    lastNbHits: number;
    lastNbPages: number;

    constructor(clientConfig: SearchClientConfig, initConfig: SearchInitConfig)
    {
        this.client = algoliasearch(clientConfig.appId, clientConfig.apiKey);
        this.index = this.client.initIndex(clientConfig.indexName);
        this.lazyloading = clientConfig.lazyLoading;
        this.hitsPerPage = clientConfig.hitsPerPage;
        this.initConfig = initConfig;
        this.clientConfig = clientConfig;
        this.searchEvents = new SearchEvents(document.getElementById(initConfig.searchBoxId));
    }

    public filterOptions(elementID, selectedField, skipCamelSpace = false) {
        let filterDiv = document.getElementById(elementID) as HTMLDivElement;
        if(filterDiv){
            let si = setInterval(() => {
                clearInterval(si);

                // if select
                let selectField = filterDiv.querySelector('select');
                if (selectField) {
                    selectField.value = selectedField;
                    selectField.dispatchEvent(new Event("change"));
                    return;
                }

                // else if refinementlist

                // convert to camel case for legacy support
                // added param to disable this ability fixes coned on load issue
                if (selectedField.includes(" ")) {
                    if (!skipCamelSpace) {
                        selectedField = Utility.toCamelCase(selectedField);
                    }
                }

                // check if selectedField is an array
                if (selectedField.includes(",")) {
                    selectedField = selectedField.split(",");
                }

                let inputFilters = filterDiv.querySelectorAll<HTMLInputElement>('input');
                inputFilters.forEach(item => {
                    let selectedFields = Array.isArray(selectedField) ? selectedField : [selectedField];
                    selectedFields.forEach(field => {
                        if (field.toLowerCase() === item.value.toLowerCase()) {
                            item.click();
                            item.checked = true;
                            item.dispatchEvent(new Event('click'));
                        }
                    });
                });
                }, 100);  // use events system instead in the future for reliable results
        }
    }

    addViewFilter(viewFilterConfig: ViewFilterConfig) {
        const self = this;
    
        let element = document.getElementById(viewFilterConfig.elementId) as HTMLElement;
    
        if (!element) {
            console.log(`Error: filter element ${viewFilterConfig.elementId} not found, check ID`);
            return;
        }
    
        let displayName = element.dataset.name;
        let attribute = element.dataset.filterName;
        let defaultFilterButton = "checkbox";
        if(element.dataset.filterType !== undefined){
            defaultFilterButton = element.dataset.filterType;
        }
        if (viewFilterConfig.filterType == ViewFilterType.Clear) {
            this.addViewClearFilter(viewFilterConfig);
        } else if (viewFilterConfig.filterType == ViewFilterType.MultiSelect) {
            this.addViewMultiSelectFilter(displayName, attribute, viewFilterConfig, element);
        } else if (viewFilterConfig.filterType == ViewFilterType.RefinementList) {
            this.addViewRefinementList(displayName, attribute, viewFilterConfig, defaultFilterButton);
        } else if (viewFilterConfig.filterType == ViewFilterType.SortBy) {
            this.addViewSortByFilter(displayName, attribute, viewFilterConfig);
        } else {
            this.addViewSelectFilter(displayName, attribute, viewFilterConfig);
        }
    }
    

    private addViewClearFilter(viewFilterConfig: ViewFilterConfig) {

        let excludedAttributes = viewFilterConfig.clearExcludedAttributes? viewFilterConfig.clearExcludedAttributes : [];

        let cssClasses = viewFilterConfig.cssClasses;
        if (!viewFilterConfig.cssClasses) {
            viewFilterConfig.cssClasses = {
                button: [
                    'btn btn-filter-clear d-flex align-items-center ms-3'
                ]
            }
        }

        this.filterWidgets.push(clearRefinements({
            container: `#${viewFilterConfig.elementId}`,
            excludedAttributes: excludedAttributes,
            templates: {
                resetLabel: 'Clear All <ion-icon class="d-inline-block ms-1" name="close-circle-outline"></ion-icon>',
            },
            cssClasses: viewFilterConfig.cssClasses
        }));
    }

    private viewFilterURLParam(viewFilterConfig: ViewFilterConfig) {
        const self = this;
        let rcontainer = document.getElementById(viewFilterConfig.elementId);
        let rendered = rcontainer.dataset.rendered;
        if (rendered != "true") {
            rcontainer.dataset.rendered = "true";
            // if urlparm, on load trigger it
            if (viewFilterConfig.urlParam) {
                let urlSearchParams = new URLSearchParams(window.location.search);
                let uparm = urlSearchParams.get(viewFilterConfig.urlParam);
                if (uparm) {
                    self.filterOptions(viewFilterConfig.elementId, uparm, viewFilterConfig.urlSpace);
                }
            }
        }
    }

    private addTranslationParm(viewFilterConfig: ViewFilterConfig) {
        let checkFilter = document.getElementById(viewFilterConfig.elementId);
        if (checkFilter) {
            if (viewFilterConfig.urlParam) {
                let algoliaKey = checkFilter.dataset.filterName;
                let urlParam = viewFilterConfig.urlParam;
                this.filterURLTranslations.push({
                    key: algoliaKey,
                    newKey: urlParam
                });
            }
        }
    }

    private addViewRefinementList(displayName: string, attribute: string, viewFilterConfig: ViewFilterConfig, filterButtonType : string) {
        // add refinement list filter type settings
        let self = this;

        let defaultSortBy = ['name:asc'];
        let sortBy = viewFilterConfig.sortBy? viewFilterConfig.sortBy : defaultSortBy;
        let capitalize = viewFilterConfig.capitalize == false? viewFilterConfig.capitalize : true;

        //let element = document.getElementById(viewFilterConfig.elementId) as HTMLElement;
        let defaultTemplates = {
            item: `<input id="{{id}}" class="form-check-input" type="checkbox" name="{{attributeName}}" value="{{value}}" {{#isRefined}}checked{{/isRefined}}> <label for="{{id}}" class="form-check-label">{{label}}</label>`,
        };
        if(filterButtonType === "toggle-button"){
            defaultTemplates = {
                item: `<input id="{{id}}" class="form-toggle-checkbox" type="checkbox" name="{{attributeName}}" value="{{value}}" {{#isRefined}}checked{{/isRefined}}> <label for="{{id}}" class="toggle-label"></label><span class="toggle-text">{{label}}</span>`,
            };
        }

        let cssClasses = viewFilterConfig.cssClasses? viewFilterConfig.cssClasses : {};
        cssClasses = Object.assign(cssClasses, {
            list: "list-unstyled no-user-select"
        });

        // add translation param
        self.addTranslationParm(viewFilterConfig);

        let filter =  refinementList({
            container: `#${viewFilterConfig.elementId}`,
            attribute: attribute,
            sortBy: sortBy,
            limit: 55, //This is a fix to increase the limit for facet filters
            transformItems(items, { results }) {

                // check if the widget has been rendered and set url param
                self.viewFilterURLParam(viewFilterConfig);

                items.forEach(function(item) {
                    if (viewFilterConfig.modFn)
                    {
                        item = viewFilterConfig.modFn(item);
                    }

                    //prevent duplicate "certificate" IDs
                    let itemID = "";
                    if(item.value == "ConEd-Certificate"){
                        itemID = "input-conEdCertificate";
                    } else {
                        itemID = "input-"+item.label.replaceAll(" ","");
                    }

                    Object.assign(item, {id:itemID});
                });
                items.sort(function(a, b){
                    return a.label === b.label ? 0 : a.label < b.label ? -1 : 1;
                });
                return items;
            },
            templates: defaultTemplates,
            cssClasses: cssClasses
        });

        this.filterWidgets.push(
            filter
        );
    }

    private addViewMultiSelectFilter(displayName: string, attribute: string, viewFilterConfig: ViewFilterConfig, element: HTMLElement) {
        const self = this;

        let defaultSortBy = ['name:asc'];
        let sortBy = viewFilterConfig.sortBy? viewFilterConfig.sortBy : defaultSortBy;
        let capitalize = viewFilterConfig.capitalize == false? viewFilterConfig.capitalize : true;

        let defaultTemplates = {
            item: '<label><input class="form-check-input" type="checkbox" name="{{attributeName}}" value="{{label}}" {{#isRefined}}checked{{/isRefined}}> {{label}}</label>',
        };

        let cssClasses = viewFilterConfig.cssClasses? viewFilterConfig.cssClasses : {};
        cssClasses = Object.assign(cssClasses, {
            list: "list-unstyled no-user-select"
        });

        // add translation param
        self.addTranslationParm(viewFilterConfig);

        // create accordion
        if (element) {
            // convert to accordion and add back the dom element inside
            const currentElementOuterHTML = element.outerHTML;
            element.id = Utility.uuidv4();
            element.innerHTML = Mustache.render(accordionContainerTemplate, {
                filter: currentElementOuterHTML,
                displayName: displayName,
                id: Utility.uuidv4()
            });
        }


        let filter =  refinementList({
            container: `#${viewFilterConfig.elementId}`,
            attribute: attribute,
            sortBy: sortBy,
            limit: 55, //This is a fix to increase the limit for facet filters
            transformItems(items, { results }) {
                // check if the widget has been rendered and set url param
                self.viewFilterURLParam(viewFilterConfig);

                items.forEach(function(item) {
                    if (viewFilterConfig.modFn)
                    {
                        item = viewFilterConfig.modFn(item);
                    }
                });
                items.sort(function(a, b){
                    return a.label === b.label ? 0 : a.label < b.label ? -1 : 1;
                });
                return items;
            },
            templates: defaultTemplates,
            cssClasses: cssClasses
        });

        const refinementListContainer = document.getElementById(viewFilterConfig.elementId);
        refinementListContainer.addEventListener('click', function(event: Event) {

            let filterCheckbox: HTMLInputElement = event.target as HTMLInputElement;
            const itemClicked = (() => {
                if (filterCheckbox && filterCheckbox.tagName === 'INPUT') {
                    const filterValue = filterCheckbox.value;
                    const tagSetting = viewFilterConfig.multiSelectConfig.tagColours.find((x) => x.tag === filterValue);
                    const ul = document.querySelector(viewFilterConfig.multiSelectConfig.tagContainer) as HTMLUListElement;

                    (async function() {
                        let listElementId: string = await Utility.sha256(filterCheckbox.value);
                        listElementId = `tag-${listElementId.slice(0, 8)}`;

                        const liElement = document.getElementById(listElementId);

                        if (liElement) {
                            liElement.remove();
                        } else {
                            // create tag element
                            const li = document.createElement('li');
                            const a = document.createElement('a');
                            // list props
                            li.id = listElementId;
                            li.setAttribute('class', `list-inline-item my-1 ${tagSetting.color}`);
                            // archor props
                            a.setAttribute('href', '#');
                            a.innerHTML = `${filterCheckbox.value} <ion-icon name="close-outline"></ion-icon>`;
                            a.classList.add('text-capitalize');
                            li.addEventListener('click', function(event: Event) {
                                event.preventDefault();
                                const liElement = document.getElementById(listElementId);
                                liElement.remove();

                                filterCheckbox.click();
                                //filterCheckbox.dispatchEvent(new MouseEvent('click'));
                            });
                            li.appendChild(a);
                            ul.appendChild(li);
                        }
                    }());
                }
            });
            itemClicked();
        });

        this.filterWidgets.push(
            filter
        );
    }

    private addViewSortByFilter(displayName: string, attribute: string, viewFilterConfig: ViewFilterConfig) {
        const self = this;
    
        // Handle custom CSS
        const defaultCssClasses = { select: "form-select d-lg-block" };
        const cssClasses = viewFilterConfig.cssClasses ? viewFilterConfig.cssClasses : defaultCssClasses;
    
        // Determine correct sorting indices dynamically
        let sortingItems = [];
    
        if (viewFilterConfig.elementId === "search-box-sortby") {
            // Sorting for programs and courses
            sortingItems = [
                { label: 'Alphabetical A - Z', value: 'programs-courses' },
                { label: 'Alphabetical Z - A', value: 'programs-courses-title-desc' },
            ];
        } else if (viewFilterConfig.elementId === "search-box-coned-sortby") {
            // Sorting for coned courses
            sortingItems = [
                { label: 'Alphabetical A - Z', value: 'coned' },
                { label: 'Alphabetical Z - A', value: 'coned-title-desc' } 
            ];
        }
    
        // Initialize the sortBy widget
        const filter = sortBy({
            container: `#${viewFilterConfig.elementId}`,
            cssClasses: cssClasses,
            items: sortingItems,
        });
    
        // Add translation param
        self.addTranslationParm(viewFilterConfig);
    
        this.filterWidgets.push(filter);
    }

    private addViewSelectFilter(displayName: string, attribute: string, viewFilterConfig: ViewFilterConfig) {
        const self = this;

        let defaultSortBy = ['name:asc'];
        let sortBy = viewFilterConfig.sortBy? viewFilterConfig.sortBy : defaultSortBy;
        let capitalize = viewFilterConfig.capitalize == false? viewFilterConfig.capitalize : true;

        // default templates for select widget
        let defaultTemplates = {
            defaultOption: `${displayName} (All)`,
            item: '{{label}} ({{count}})',
        };
        let templates = viewFilterConfig.templates? viewFilterConfig.templates : defaultTemplates;

        // default css classes for select widget
        let defaultCssClasses = {
            select: "pc-filter"
        };
        let cssClasses = viewFilterConfig.cssClasses? viewFilterConfig.cssClasses : defaultCssClasses;

        // add translation param
        self.addTranslationParm(viewFilterConfig);

        let filter =  menuSelect({
            container: `#${viewFilterConfig.elementId}`,
            attribute: attribute,
            sortBy: sortBy,
            limit: 150, //This is a fix to increase the limit for facet filters
            transformItems(items, { results }) {
                // check if the widget has been rendered and set url param
                self.viewFilterURLParam(viewFilterConfig);

                items.forEach(function(item) {
                    if (viewFilterConfig.modFn)
                    {
                        item = viewFilterConfig.modFn(item);
                    }
                    if (capitalize) {
                        const cap = (string) => {
                            return string.charAt(0).toUpperCase() + string.slice(1);
                        };
                        item.label = cap(item.label);
                    }
                });
                items.sort(function(a, b){
                    return a.label === b.label ? 0 : a.label < b.label ? -1 : 1;
                })
                return items;
            },
            cssClasses: cssClasses,
            templates: templates
        });

        this.filterWidgets.push(
            filter
        );

        // Add a label to the select element created by the menuSelect widget
        function addLabelToSelectElement() {
            const selectElement = document.querySelector(`#${viewFilterConfig.elementId} .ais-MenuSelect-select`);
            if (selectElement) {
                const parentDiv = selectElement.closest('.ais-MenuSelect');
                if (parentDiv && !parentDiv.querySelector('label')) {
                    const label = document.createElement('label');
                    label.textContent = `${displayName}`; // Use the displayName as the label text
                    label.setAttribute('for', (selectElement as HTMLSelectElement).id);
                    label.classList.add('form-label'); // Add a class to the label for consistent styling
                    label.classList.add('visually-hidden');
                    parentDiv.insertBefore(label, selectElement);

                    // Add an id to the select element for the label to reference
                    if (!(selectElement as HTMLSelectElement).id) {
                        (selectElement as HTMLSelectElement).id = `${viewFilterConfig.elementId}-select`;
                    }
                }
            }
        }
        // Use MutationObserver to watch for changes in the DOM
        const observer = new MutationObserver((mutationsList, observer) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    const selectElement = document.querySelector(`#${viewFilterConfig.elementId} .ais-MenuSelect-select`);
                    if (selectElement) {
                        addLabelToSelectElement();
                        observer.disconnect(); // Stop observing once the element is found and processed
                        break;
                    }
                }
            }
        });
        // Start observing the target node for configured mutations
        observer.observe(document.body, { childList: true, subtree: true });
    }

    // override
    onLoad(facets: Array<any>) {}

    public updateViewFilter(id: string, value: string)
    {
        let filterParent = document.getElementById(id);

        // create a function to select the value and send change event
        let selectFn = function(parent: HTMLElement)
        {
            let select = parent.querySelector("select");
            if (select)
            {
                let doesValueExist = select.querySelector("option[value='"+value+"']");
                if (doesValueExist)
                {
                    // select value exists, change filter
                    select.value = value;
                    select.dispatchEvent(new Event('change'));
                }
            }
        };

        if (filterParent)
        {
            selectFn(filterParent as HTMLElement);
        } else {
            // try a wild card search
            let filterParentWild = document.querySelector("[id*='" + id + "']");
            if (filterParentWild)
            {
                selectFn(filterParentWild as HTMLElement);
            }
        }
    }

    // add facet to this.facets to keep track of facets for algolia | action: on algolia helper.search()
    addFacet(facet: facet, overwrite: boolean = true)
    {
        let facetFound = this.facets.find(x => x.field === facet.field);
        if (facetFound) {
            if(facet.value.includes("|"))
            {
                facet.disjunctive = true;
            }

            if (facet.disjunctive) {
                facetFound.values = facet.values;
                //self.search.helper.state.disjunctiveFacetsRefinements
                //facet.value.replaceAll("|", ",");
                if (overwrite) {
                    this.search.helper.state.disjunctiveFacetsRefinements[facetFound.field] = facetFound.values;
                    //}
                    //this.search.helper.state.disjunctiveFacetsRefinements[facetFound.field] = facetFound.values;
                } else {
                    // console.log('not overwritting');
                }
                // else silently fail, facet already filled
            } else {
                // new value for facet
                if (overwrite) {
                    facetFound.value = facet.value;
                    if(this.search.helper.state.facetsRefinements[facetFound.field][0]){
                        this.search.helper.state.facetsRefinements[facetFound.field][0] = facetFound.value;
                    }
                }
                // else silently fail, facet already filled
            }
        } else {
            this.facets.push(facet);
        }
    }

    // just simple facets for browser html filtering usage
    filter(name, value) {
        this.addFacet({
            field: name,
            value: value
        }, true);
        this.search.helper.search();
    }

    // remove facet from this.facets to remove from algolia request | action: immediate
    removeFacet(field: string)
    {
        let self = this;
        let obj = this.facets.find((facet, i) => {
            if (facet.field === field) {
                /* removeFacetRefinement and removeDisjunctiveFacetRefinement do not seem to work as intended
                so I had to remove facets manually from self.search.helper.state.[disjunctiveFacets] or [facets]
                */
                if (facet.disjunctive) {
                    // remove using algolia
                    //self.search.helper.removeDisjunctiveFacetRefinement(facet.field);
                    // remove old facet
                    self.search.helper.state.disjunctiveFacets.splice(self.search.helper.state.disjunctiveFacets.indexOf(field), 1);
                    // remove facet
                    delete self.search.helper.state.disjunctiveFacetsRefinements[field];
                } else {
                    // remove facet
                    //self.search.helper.removeFacetRefinement(facet.field);
                    // remove old facet
                    self.search.helper.state.facets.splice(self.search.helper.state.facets.indexOf(field), 1);
                    // remove facet
                    delete self.search.helper.state.facetsRefinements[field];
                }
                // remove from class facets
                this.facets.splice(i, 1);
                return true;
            }
        });
    }

    removeAllFacets()
    {
        let self = this;
        this.facets.forEach(function(facet){
            self.removeFacet(facet.field);
        });
        this.search.helper.clearRefinements();
        //this.search.helper.clearRefinements().search();
        //this.search.helper.clearCache();
        //this.search.helper.search();
    }

    init()
    {
        let self = this;
        //This is to remove the sentinal from the page - infinite scroll
        if (!self.initConfig.hasOwnProperty("infiniteScroll")) {
            self.initConfig.infiniteScroll = true;
        }
        self.templates = self.initConfig.templates;
        self.activeTemplate = self.initConfig.activeTemplate;
        this.resultContainer = document.getElementById(self.initConfig.resultContainerId) as HTMLElement;

        // if customRender is not defined use a default one
        if (!self.initConfig.customRender) {
            this.customRender = function(item) {
                return item;
            }
        } else {
            this.customRender = self.initConfig.customRender;
        }
        const insightsMiddleware = createInsightsMiddleware({
            insightsClient: aa //,
            // insightsInitParams: {
            //     // useCookie: true,
            // }
        });

        // may cause error on null
        try {
            aa('setUserToken', window.saitIdent);
        } catch (err) {
            // assign a universal idenity
            window.saitIdent = `backup-${Utility.uuidv4}`;
            aa('setUserToken', window.saitIdent);
        }
        window.aa = aa;

        var getCategorySlug = function(name) {
            return name
                .split(' ')
                .map(encodeURIComponent)
                .join('+');
        }

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
        var getCategoryName = function(slug) {
            return slug
                .split('+')
                .map(decodeURIComponent)
                .join(' ');
        }

        // let renameKey = (oldKey: string, newKey: string, o: any)=> {
        //     if (oldKey !== newKey) {
        //         Object.defineProperty(o, newKey,
        //             Object.getOwnPropertyDescriptor(o, oldKey));
        //         delete o[oldKey];
        //     }
        //     return o;
        // }

        // init search
        this.search = instantsearch({
            indexName: this.index.indexName,
            searchClient: this.client,
            routing: {
                router: history({
                    parseURL: function({ qsModule, location }) {
                        const parsedParams = qsModule.parse(location.search, {
                            ignoreQueryPrefix: true,
                            parseArrays: true,
                            comma: true
                        });

                        let params: any = {};

                        // Translate keys from URL parameters
                        const translateKeys = [
                            { key: "areaofinterest", newKey: "metaData.categories.categories.programClass.aois" },
                            { key: "credential", newKey: "recordObj.filterCredential"},
                            { key: "international", newKey: "recordObj.internationalStudents.acceptedFilter" },
                            { key: "filter-categoryExpert", newKey: "recordObj.expertCategoryObj"}
                        ];

                        Object.keys(parsedParams || {}).forEach((attribute) => {
                            let key = attribute;
                            let val = parsedParams[attribute];


                            console.log("url key", key);
                            console.log("url val", val);

                            const foundTranslation = translateKeys.find(item => item.key === key);
                            if (foundTranslation) {
                                key = foundTranslation.newKey;
                            }

                            // Handle comma-separated string refinements
                            if (typeof val === 'string' && val.includes(",")) {
                                val = val.split(",");
                            }

                            params[key] = val;
                        });

                        return {
                            query: decodeURIComponent(""),
                            page: 1,
                            refinementList: params
                        };
                    },

                    createURL: function({ qsModule, routeState, location }) {
                        const filterParameters: any = {};
                        let queryString = "";
                        let indexState = routeState[self.search.indexName];

                        if (indexState) {
                            // translate refinement list
                            Object.keys(indexState.refinementList || {}).forEach((attribute) => {
                                let key = attribute;
                                let val = indexState.refinementList[attribute];

                                const foundTranslation = self.filterURLTranslations.find(item => item.key === key);
                                if (foundTranslation) {
                                    key = foundTranslation.newKey;
                                }

                                filterParameters[key] = val;
                            });

                            // translate menu list
                            Object.keys(indexState.menu || {}).forEach((attribute) => {
                                let key = attribute;
                                let val = indexState.menu[attribute];

                                const foundTranslation = self.filterURLTranslations.find(item => item.key === key);
                                if (foundTranslation) {
                                    key = foundTranslation.newKey;
                                }

                                filterParameters[key] = val;
                            });

                            if(indexState["query"]) {
                                let key = self.initConfig.queryName? self.initConfig.queryName : "query";
                                filterParameters[key] = indexState["query"];
                            }

                            // refinement array to string
                            queryString = qsModule.stringify(filterParameters, {
                                addQueryPrefix: true,
                                arrayFormat: 'comma'
                            });
                        }
                        return `${queryString}`;
                    }
                }),

                stateMapping: {
                    stateToRoute(uiState: any) {
                        const indexState = uiState[Object.keys(uiState)[0]];

                        // Collect all active refinements dynamically
                        Object.keys(indexState.refinementList || {}).forEach((attribute) => {
                            const refinements = indexState.refinementList[attribute];
                            if (refinements && refinements.length) {
                                indexState.refinementList[attribute] = refinements;
                            }
                        });

                        // console.log("stateToRoute");
                        // console.log(uiState);

                        return uiState;
                    },

                    routeToState(routeState: any) {
                        const indexName = Object.keys(routeState)[0];
                        const refinements = routeState[indexName]?.refinementList || {};

                        // console.log("stateToRoute");
                        // console.log({
                        //     [indexName]: {
                        //         query: routeState.query || '',
                        //         page: routeState.page || 1,
                        //         refinementList: refinements,
                        //     }
                        // });

                        return {
                            [indexName]: {
                                query: routeState.query || '',
                                page: routeState.page || 1,
                                refinementList: refinements,
                            }
                        };
                    }
                }
            },
            searchFunction: function (helper) {

                // custom search - trigger even if empty
                if (self.customSearch)
                {
                    self.customSearch(helper);
                }

                // check query length
                if(helper.state.query.length === 0) {
                    // hide on first load
                    if (self.isFirstLoad && self.initConfig.showOnLoad)
                    {
                        // let the search go through
                    } else {
                        if (self.initConfig.allowEmptyQuery) {
                            // allow an empty query
                        } else {
                            return; // don't do any search
                        }
                    }

                    // hide header text
                    if (self.initConfig.headerText)
                    {
                        let headerTextElement = document.getElementById('algoliaHeaderText');

                        if (headerTextElement)
                        {
                            headerTextElement.classList.add('d-none');
                        }
                    }
                }

                // if (self.initConfig.queryName && self.isFirstLoad)
                // {
                //     console.log("First load - in search init");
                //     Utility.getUrlParameter(self.initConfig.queryName)
                // }

                //set url query
                if (self.initConfig.queryName && helper.state.query != "")
                {
                    Utility.setUrlParameter(self.initConfig.queryName, helper.state.query);
                }

                // compile filters
                self.facetsCompile(helper);

                // search
                helper.search();
            }
        });

        // add insights middleware
        this.search.use(insightsMiddleware);

        // view style buttons
        if (self.initConfig.buttonClassTargets)
        {
            let searchContainer = document.querySelector('.search-container');
            let gridBtn: HTMLElement = searchContainer.getElementsByClassName(self.initConfig.buttonClassTargets.grid)[0] as HTMLElement;
            let listBtn: HTMLElement = searchContainer.getElementsByClassName(self.initConfig.buttonClassTargets.list)[0] as HTMLElement;
            if(gridBtn){
                // grid button display
                gridBtn.addEventListener('click', function() {
                    self.activeTemplate = 'grid';

                    let resultsList = document.getElementById(self.initConfig.resultContainerId);
                    if (resultsList)
                    {
                        let rootUl = resultsList.querySelector('ul');
                        if (rootUl)
                        {
                            rootUl.classList.add('row');
                        }
                    }

                    // remove active class from list
                    listBtn.classList.remove('active');

                    // add active class to grid
                    this.classList.add('active');

                    // refresh results
                    self.search.helper.search();
                });
            }
            if(listBtn){
                // list button display
                listBtn.addEventListener('click', function() {
                    self.activeTemplate = 'list';

                    let resultsList = document.getElementById(self.initConfig.resultContainerId);
                    if (resultsList)
                    {
                        let rootUl = resultsList.querySelector('ul');
                        if (rootUl)
                        {
                            rootUl.classList.remove('row');
                        }
                    }

                    // remove active class from grid
                    gridBtn.classList.remove('active');

                    // add active class to list
                    this.classList.add('active');
                    self.search.helper.search();
                });

            }

            if(window.innerWidth <= 992) {
                self.activeTemplate = 'list';
                gridBtn.classList.remove('active');
                listBtn.classList.add('active');
            }
        }

        // create the custom connectInfiniteHits widget
        // instantiate customInfiniteHits
        const customInfiniteHits = (widgetParams: { container: HTMLElement; }) => {
            return connectInfiniteHits(self.infiniteHitsRender(config, widgetParams));
        }

        const customHits = customInfiniteHits({
            container: self.resultContainer
        });

        var textboxPlaceholder = self.initConfig.textboxPlaceholder? self.initConfig.textboxPlaceholder : "Search by Keyword";

        this.search.addWidgets([
            searchBox({
                container: `#${self.initConfig.searchBoxId}`,
                queryHook: function (query, search)
                {
                    search(query);
                },
                placeholder: textboxPlaceholder,
                searchAsYouType: true,
                showReset: false,
            }),
            customHits({
                escapeHTML: false
            }),
        ]);

        let isBannerOnPage = document.getElementById(`${self.initConfig.searchBoxId}-search-banner`);
        if (isBannerOnPage) {
            this.search.addWidgets([
                queryRuleCustomData({
                    container: `#${self.initConfig.searchBoxId}-search-banner`,
                    templates: {
                        default: bannerSuggestedLinks,
                    },
                    transformItems(items, { results }) {
                        // find wildcard listing and set template type
                        let wildcard: null | any = null;
                        items.forEach(function(item) {
                            if (item.bannerType == "suggested-links")
                            {
                                item.isSuggested = true;
                            } else if (item.bannerType == "school")
                            {
                                item.isSchool = true;
                            } else if (item.bannerType == "event")
                            {
                                item.isEvent = true;
                            } else if (item.bannerType == "information")
                            {
                                item.isInfo = true;
                            } else if (item.bannerType == "program-banner") {
                                item.isProgramBanner = true;
                            }  else if (item.bannerType == "program-event-banner") {
                                item.isEventProgramBanner = true;
                            }else if(item.bannerType == "infoSessions") {
                                item.isInfoSessions = true;
                            }

                            if (!item.keywords)
                            {
                                wildcard = item;
                            }
                        });

                        // sometimes duplicate results happen, only pick the first result
                        if (items.length >= 1)
                        {
                            // prune banner to one result
                            let nonWild = items.filter(i => i['keywords'] !== undefined);
                            if (nonWild.length > 0) {
                                items = [nonWild[0]];
                            } else {
                                items = [];
                            }
                        }

                        // append wild card to listing
                        if (wildcard)
                        {
                            items.unshift(wildcard);
                        }
                        return items;
                    }
                })
            ]);
        }


        if (this.filterWidgets.length > 0) {
            this.search.addWidgets(this.filterWidgets);
        }

        this.start();
    } //init end

    start() {
        const self = this;
        self.search.start();

        // on results render
        self.search.on('render', function() {
            if (self.lazyloading) {
                window.lazyload.update();
            }
        });

        // remove query parm on empty keyup input
        let searchInput = document.getElementById(`${self.initConfig.searchBoxId}`).querySelector('.ais-SearchBox-input') as HTMLInputElement;
        searchInput.addEventListener('keyup', function() {
            self.searchEvents.emit(SearchEventTypes.KeyUp, {input: searchInput});
            if (searchInput.value == "") {
                if (self.initConfig.queryName) {
                    Utility.removeUrlParameter(self.initConfig.queryName);
                }
            }
        });
    }

    setSearchBoxValue(value: string) {
        // set a text value to the searchbox and than fire event to search
        let textbox = document.querySelector(`#${this.initConfig.searchBoxId} > .ais-SearchBox > .ais-SearchBox-form > .ais-SearchBox-input`) as HTMLInputElement;
        if (textbox) {
            textbox.value = value;
            if (textbox.value == "") {
                if (this.initConfig.queryName) {
                    Utility.removeUrlParameter(this.initConfig.queryName);
                }
            }
            textbox.dispatchEvent(new Event('input'));
        }
    }

    getSearchBoxValue(): string | null {
        // set a text value to the searchbox and than fire event to search
        let textbox = document.querySelector(`#${this.initConfig.searchBoxId} > .ais-SearchBox > .ais-SearchBox-form > .ais-SearchBox-input`) as HTMLInputElement;
        if (textbox) {
            return textbox.value
        }
        return null;
    }

    infiniteHitsRender(config, options) {
        let self = this;
        let lastRenderArgs;
        let observer; // Declare observer globally within the function scope

        const renderHits = (renderOptions, isFirstRender) => {
            const { currentPageHits, hits, showMore, widgetParams } = renderOptions;
            const { container } = options;
            lastRenderArgs = renderOptions;

            let openAccordions = [];
            const accordions = container.querySelectorAll('.accordion-header');
            accordions.forEach((accordion) => {
                const button : HTMLButtonElement = accordion.querySelector('.accordion-button');
                if (button.classList.contains('collapsed')){
                    // closed
                } else {
                    // opened
                    openAccordions.push(button.dataset.bsTarget);
                }
            });

            // Custom event call, valid only if it's not the first render
            self.searchEvents.updateData({
                currentPageHits: currentPageHits,
                showMore: showMore,
                widgetParams: widgetParams,
                container: container
            });

            // Initialize IntersectionObserver and sentinel element only on first render
            if (isFirstRender) {
                self.isFirstLoad = isFirstRender;

                const rootUl = document.createElement('ul');
                const sentinel = document.createElement('div');

                // add senti class
                sentinel.classList.add('algolia-sentinel');

                // make list unstyled
                rootUl.classList.add('list-unstyled');

                // add root classes to ul
                if (self.initConfig.cssClasses)
                {
                    if (self.initConfig.cssClasses.root)
                    {
                        rootUl.className = self.initConfig.cssClasses.root;
                    }
                }
                container.appendChild(rootUl);
                container.appendChild(sentinel);

                // add header text if configured
                if (self.initConfig.headerText) {
                    const headerText = document.createElement('h4');
                    headerText.id = "algoliaHeaderText";
                    headerText.textContent = this.initConfig.headerText;
                    headerText.classList.add('mt-3', 'mb-2', 'd-none');
                    container.appendChild(headerText);
                }

                observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && entry.intersectionRatio >= 1) {
                            if(self.initConfig.infiniteScroll) {
                                showMore();
                            }
                        }
                    });
                }, {
                    threshold: [1],
                    rootMargin: '0px 0px 200px 0px'
                });

                // delay the observer start to avoid accidental triggers on page load
                setTimeout(() => observer.observe(sentinel), 1000);
            } else {
                self.isFirstLoad = false;
            }

            // set search count on self
            self.currentHitCount = hits.length;

            if (hits.length > 0) {
                // show header text
                if (self.initConfig.headerText)
                {
                    let headerTextElement = document.getElementById('algoliaHeaderText');
                    if (headerTextElement)
                    {
                        headerTextElement.classList.remove('d-none');
                    }
                }

                // render results
                if (self.initConfig.overrideRender) {
                    self.initConfig.overrideRender.fn(container.querySelector('ul'), hits);
                } else {
                    container.querySelector('ul').innerHTML = hits
                        .map((hit) => {
                            // console.log(hit);
                            hit = self.customRender(hit);

                            // wrike#1437040086 fix for html entities
                            if (hit.hasOwnProperty('metaData')) {
                                if (hit.metaData.description) {
                                    hit.metaData.description = utility.htmlDecode(hit.metaData.description);
                                }
                            }

                            // add click event for analytics
                            hit.clickEvent = `window.aa('clickedObjectIDsAfterSearch', {
                            userToken: '${window.saitIdent}',
                            eventName: 'search item click',
                            index: '${self.clientConfig.indexName}',
                            queryID: '${hit.__queryID}',
                            objectIDs: ['${hit.objectID}'],
                            positions: [${hit.__position}]
                        })`;

                            // debug
                            let renderedItem = Mustache.render(self.templates[self.activeTemplate], hit);
                            let doc = new DOMParser().parseFromString(renderedItem, "text/html");
                            let accordTargetId = `#--cc-collapse-${hit.objectID}`;
                            let accordBodyId = `--cc-collapse-${hit.objectID}`;
                            // console.log("render", doc);
                            // console.log("render item string", doc.documentElement.innerHTML);
                            // console.log("render item id", hit.objectID);
                            // console.log("render hit", hit);
                            // console.log("in array", openAccordions.includes(`#--cc-collapse-${hit.objectID}`));

                            if (openAccordions.includes(`#--cc-collapse-${hit.objectID}`)) {
                                // update button values for accordion
                                const buttonElement: HTMLButtonElement = doc.querySelector(`button[data-bs-target='${accordTargetId}']`);
                                buttonElement.classList.toggle('collapsed');
                                buttonElement.setAttribute('aria-expanded', 'true');

                                // update body for accordion
                                const panelElement: HTMLElement = doc.getElementById(accordBodyId);
                                panelElement.classList.toggle('show');
                            }

                            // render the hit
                            return doc.documentElement.innerHTML
                        }).join('');
                }
            } else {

                // is first render
                if (isFirstRender) {
                    if (self.initConfig.firstRenderFn){
                        self.initConfig.firstRenderFn(self);
                    }
                    return;
                }

                this.searchEvents.emit(SearchEventTypes.NoResults);
                if (self.templates.hasOwnProperty('empty'))
                {
                    container.querySelector('ul').innerHTML =  Mustache.render(self.templates.empty, lastRenderArgs);
                } else {
                    container.querySelector('ul').innerHTML =  Mustache.render("No results", lastRenderArgs);
                }
            }

            if (renderOptions.results) {
                self.searchEvents.updateData({
                    renderOptions: renderOptions,
                    hitsCount: renderOptions.results.nbHits
                });
            }

            // // update state of the accordions after rendering new hits
            // openAccordions.forEach((bsTarget) => {
            //     const buttonElement: HTMLButtonElement = document.querySelector(`button[data-bs-target='${bsTarget}']`);
            //     buttonElement.click();
            // });

            // creating a custom search event
            self.searchEvents.emit(SearchEventTypes.HitsRendered);
        };

        return renderHits;
    }

    // add facets to helper object for algolia request
    private facetsCompile(helper: algoliahelper.AlgoliaSearchHelper)
    {
        let self = this;
        if (this.facets) {
            // set maxValuesPerFacet to allow more values in select field default: 10
            //helper.state.maxValuesPerFacet = 30;
            //helper.state['maxFacetHits'] = 30;
            //helper.setQueryParameter('maxValuesPerFacet', 100);
        }
        this.facets.forEach(function(facet)
        {
            if(facet.value.includes("|")) {
                facet.disjunctive = true;
                // console.log("complile dis");
            }

            if(facet.disjunctive) {
                if (!(helper.state.disjunctiveFacets.indexOf(facet.field) > -1))
                {
                    helper.state.disjunctiveFacets.push(facet.field);
                    if(facet.values){
                        facet.values.forEach(function(value) {
                            helper.addDisjunctiveFacetRefinement(facet.field, value);
                        });
                    }
                    else{
                        facet.value.split("|").forEach(facetVal=>{
                            // console.log(facetVal);
                            helper.addDisjunctiveFacetRefinement(facet.field, facetVal);
                        });
                    }
                } else {
                    // // clean old facet
                    // self.removeFacet(facet.field);
                    // self.addFacet(facet)
                    // // re-add new facet
                    // helper.state.disjunctiveFacets.push(facet.field);
                    // facet.values.forEach(function(value) {
                    //     helper.addDisjunctiveFacetRefinement(facet.field, value);
                    // });
                }
            } else {
                // console.log(self);
                if (!(helper.state.facets.indexOf(facet.field) > -1)) {
                    helper.state.facets.push(facet.field);
                    helper.addFacetRefinement(facet.field, facet.value);
                    // console.log("single complie");
                } else {
                    // clean old facet
                    // self.removeFacet(facet.field);
                    // self.addFacet({
                    //     field: facet.field,
                    //     value: facet.value
                    // })
                    // // re-add new facet
                    // helper.state.facets.push(facet.field);
                    // helper.addFacetRefinement(facet.field, facet.value);
                }
            }
        });
    }
}

export default Search;
export { SearchInitConfig, SearchClientConfig, ViewFilterType };
